module.exports = __webpack_public_path__ + "static/media/info-pin.89e27f70.svg";